import EventsCreationScreen from "@/src/screens/events/events-form/events-creation-screen";

export default function EventsCreation() {
  return <EventsCreationScreen />;
}
